import {
  Alert,
  Button,
  FormControl,
  LinearProgress,
  TextField,
} from '@mui/material';
import axios, { AxiosResponse } from 'axios';
import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { BulkActionProps } from './props.interface';
import { ErrorsFlattenner } from '../errors-flattenner/errors-flattenner';
import { isMobile, isTablet } from 'react-device-detect';

function CancelOrdersAction({
  selectedOrders,
  bulkEndpoint,
  refetchOrders,
  onFinishAction,
}: BulkActionProps  & {  onFinishAction: ()=>void;}) {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>('');
  const [response, setResponse] = React.useState<AxiosResponse>();
  const [confirmationInput, setConfirmationInput] = React.useState('');
  const targetConfirmation = 'cancel orders';

  const { user, config } = useContext(AuthContext);
  const orgId = user?.organisation?.org_id;

  const handleSubmit = async () => {
    let endpoint = bulkEndpoint;
    if (orgId) {
      endpoint += `?org=${encodeURIComponent(orgId)}`;
    }

    setIsLoading(true);
    setMessage('');
    setResponse(undefined);
    const requestData = Array.from(selectedOrders.keys()).map((order_pk) => {
      const order = {
        id: order_pk,
      };
      return order;
    });

    try {
      const response = await axios.delete<OrderType[]>(endpoint, {
        ...config,
        data: requestData,
      });
      setResponse(response);
      setMessage('Orders cancelled successfully');
      refetchOrders();
      onFinishAction();
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage('Failed to cancel orders: ' + e.response?.statusText);
      } else {
        setMessage('Failed to cancel orders');
      }
    }
    setIsLoading(false);
  };

  console.log(response);

  return (
    <>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <>
          {message != '' && (
            <>
              <Alert
                severity={
                  response && response.status >= 200 && response.status < 300
                    ? 'success'
                    : 'error'
                }
              >
                <>
                  {message}

                  {response && response.status >= 300 && (
                    <ErrorsFlattenner rawErrors={response.data} />
                  )}
                </>
              </Alert>
              <br />{' '}
            </>
          )}
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Alert severity="warning">This action can not be undone.</Alert>
            <br />

            <FormControl fullWidth>
              <TextField
                autoComplete="off"
                value={confirmationInput}
                onChange={(e) => setConfirmationInput(e.target.value)}
                label={'Confirm your decision'}
                placeholder={`Please type in "${targetConfirmation}" to confirm your decision`}
              />
            </FormControl>
            <br />
            <br />
            <Button
              size={(isMobile && !isTablet) ? 'small' : 'medium'}
              disabled={targetConfirmation != confirmationInput}
              variant="contained"
              type="submit"
              onClick={handleSubmit}
            >
              {' '}
              Cancel Orders{' '}
            </Button>
          </div>{' '}
        </>
      )}
    </>
  );
}

export default CancelOrdersAction;
